// @flow
import * as React from 'react';
import * as StringUtil from 'app/common/lib/StringUtil';
import i18n from 'app/common/lib/i18n';
import type { GridPin } from 'app/packages/pinterest-flow-types/pin';

type Props = {
  pin: GridPin,
  handleLinkClickthrough: Function,
  hideClickthroughLink?: ?boolean,
  ignoreUnauthClassName?: boolean,
};

const styles = {
  linkClickthrough: {
    contentLink: {
      backgroundColor: 'transparent',
      cursor: 'pointer',
      border: '0px',
      margin: '0px',
      display: 'block',
      padding: '10px 12px',
      bottom: '0px',
      left: '0px',
      position: 'absolute',
      right: '0px',
    },
    contentLinkText: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      color: '#fff',
      display: 'block',
      fontSize: '11px',
      fontWeight: '500',
      lineHeight: '18px',
    },
  },
};

const PinImageHover = ({
  pin,
  handleLinkClickthrough,
  hideClickthroughLink,
  ignoreUnauthClassName,
}: Props) => {
  function renderShowClickthroughAffHover() {
    const { domain, link } = pin;
    if (!link || !domain) {
      return null;
    }

    const clickthroughAffordanceHoverStyles = styles.linkClickthrough;
    const linkText = StringUtil.dangerouslyFormat(i18n._('Learn more at {{ domain }}'), { domain });
    return (
      <a
        className={ignoreUnauthClassName ? '' : 'GrowthUnauthPinImage__contentLink'}
        href={link}
        onClick={(e) => {
          e.stopPropagation(); // The website link should not trigger any other actions on the Pin
          handleLinkClickthrough(e);
        }}
        rel="nofollow"
        style={clickthroughAffordanceHoverStyles.contentLink}
        target="_blank"
        type="button"
      >
        <span style={clickthroughAffordanceHoverStyles.contentLinkText}>{linkText}</span>
      </a>
    );
  }

  return !hideClickthroughLink ? renderShowClickthroughAffHover() : null;
};

export default PinImageHover;
